import './style.scss';

type Props = {
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onKeyDown?: (key: string, value?: string) => void;
  value?: string;
  disabled?: boolean;
};
export const Textarea = ({
  onChange,
  value,
  onBlur,
  onKeyDown,
  disabled,
}: Props) => {
  return (
    <textarea
      className="tru-textarea"
      value={value}
      onChange={(event) => onChange?.(event.currentTarget.value)}
      onBlur={(event) => onBlur?.(event.currentTarget.value)}
      onKeyDown={(event) => onKeyDown?.(event.key, event.currentTarget.value)}
      disabled={disabled}
    />
  );
};
